<template>
  <!-- class="ts-relative ts-flex ts-w-full ts-flex-wrap ts-items-stretch ts-mb-3" -->
  <!-- <div
  > -->
  <!-- <input
      v-model="model.text"
      type="text"
      placeholder="Search:serial,product name-grade"
      class="
        ts-px-3
        ts-py-3
        ts-placeholder-blueGray-300
        ts-text-blueGray-600
        ts-relative
        ts-bg-white
        ts-rounded
        ts-text-sm
        ts-border
        ts-outline-none
        focus:ts-outline-none focus:ts-ring
        ts-w-full ts-pr-10
      "
    /> -->
  <!-- <span
      class="
        ts-z-10
        ts-h-full
        ts-leading-snug
        ts-font-normal
        ts-absolute
        ts-text-center
        ts-text-blueGray-300
        ts-bg-transparent
        ts-rounded
        ts-text-base
        ts-items-center
        ts-justify-center
        ts-w-8
        ts-right-0
        ts-pr-3
        ts-py-3
      "
    >
      <i class="fas fa-search"></i>
    </span> -->
  <!-- <a-select
    v-model="model.product_id"
    mode="multiple"
    placeholder="Search:product name|barcode"
    :loading="on_search_product"
    @search="onProductSearch"
    @change="onSelectChange"
    :show-arrow="false"
    :filter-option="true"
    :not-found-content="null"
    :filterOption="
      (input, option) =>
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
    "
    class="ts-w-full"
  >
    <a-select-option
      v-for="product in productList"
      :key="product.product_id"
      :value="product.product_id"
    >
      {{ product.product_name_en }}
    </a-select-option>
  </a-select> -->
  <on-click-outside :do="close">
    <div class="search-select ts-w-full" :class="{ 'is-active': isOpen }">
      <button
        ref="button"
        @click="open"
        type="button"
        class="search-select-input"
      >
        <span
          v-if="option !== null && option.length"
          class="search-select-text ts-space-x-2"
        >
          <span
            v-for="(s, index) in optionSelect"
            :key="index"
            class="ts-bg-gray-100 ts-border ts-px-2"
          >
            {{ s.product_name_en }}
            <span
              class="ts-p-1 ts-text-white ts-bg-red-500 ts-rounded-full ts-z-index-10"
              @click="removeSelected(s)"
              >x</span
            >
          </span>
          <span
            class="ts-bg-gray-100 ts-border ts-px-2"
            v-if="option.length > 2"
            >{{ '+' + (option.length - 2) }}</span
          >
        </span>
        <span v-else class="search-select-placeholder">--Select--</span>
        <span
          class="search-select__arrow"
          :class="{ 'search-select__arrow__open': isOpen }"
        ></span>
      </button>
      <div ref="dropdown" v-show="isOpen" class="search-select-dropdown">
        <input
          class="search-select-search"
          v-model="search"
          ref="search"
          @keydown.esc="close"
          @keydown.up="highlightPrev"
          @keydown.down="highlightNext"
          @keydown.enter.prevent="selectHighlighted"
          @input="onProductSearch"
        />
        <ul
          ref="options"
          v-show="productList.length > 0"
          class="search-select-options"
        >
          <li
            class="search-select-option"
            v-for="(option, i) in productList"
            :key="typeof option === 'object' ? option.value : option"
            @click="select(option)"
            :class="{ 'is-active': i === highlightedIndex }"
          >
            {{ typeof option === 'object' ? option.product_name_en : option }}
          </li>
        </ul>
        <div v-if="on_search_product" class="ts-text-center">
           <p>...loading</p>
        </div>
        <div v-else-if="productList.length === 0" class="search-select-empty">
          <slot name="no-result" :search="search">
            No results found for
            <b>" {{ search }}"</b>
          </slot>
        </div>
      </div>
    </div>
  </on-click-outside>

  <!-- </div> -->
</template>
<script>
import { mapActions } from 'vuex'
import { debounce } from 'lodash'
import Popper from 'popper.js'
import OnClickOutside from '@/components/OnClickOutside'

export default {
  props: ['value'],
  components: {
    OnClickOutside
  },
  data() {
    return {
      productList: [],
      on_search_product: false,
      model: {
        product_id: []
      },
      isOpen: false,
      search: '',
      option: [],
      highlightedIndex: null
    }
  },
  computed: {
    optionSelect() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.option.slice(0, 2)
    },
    filteredOptions() {
      if (this.filterFunction !== undefined) {
        return this.filterFunction(this.search, this.productList)
      }

      return this.productList.filter(option => {
        option = typeof option === 'object' ? option.product_name_en : option

        return option.toLowerCase().startsWith(this.search.toLowerCase())
      })
    }
  },
  beforeDestroy() {
    this.popper !== undefined && this.popper.destroy()
  },
  methods: {
    ...mapActions('product/label', ['getProductProfile']),
    onProductSearch: debounce(function() {
      this.productList = []
      this.on_search_product = true
      this.getProductProfile({
        text_search: this.search,
        ex_pid: this.productList.map(el => el.product_id)
      })
        .then(response => {
          this.productList.push(...response.data)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.on_search_product = false
        })
    }, 1000),
    onSelectChange() {
      this.$emit('input', this.model.product_id)
    },
    open() {
      if (!this.isOpen) {
        this.isOpen = true
        this.$nextTick(() => {
          this.setupPopper()
          this.$refs.search.focus()
          this.scrollToHighlighted()
        })
      } else {
        this.isOpen = false
      }
    },
    setupPopper() {
      if (this.popper === undefined) {
        this.popper = new Popper(this.$refs.button, this.$refs.dropdown, {
          placement: 'bottom',
          positionFixed: true,
          modifiers: {
            offset: {
              enabled: true,
              fn: data => {
                data.offsets.popper.left = data.offsets.reference.left
                data.offsets.popper.right = data.offsets.reference.right
                data.offsets.popper.width = data.styles.width = Math.round(
                  data.offsets.reference.width
                )
                return data
              },
              order: 840
            }
          }
        })
      } else {
        this.popper.scheduleUpdate()
      }
    },
    selectHighlighted() {
      this.select(this.filteredOptions[this.highlightedIndex])
    },
    scrollToHighlighted() {
      if (this.highlightedIndex === null) return

      this.$refs.options.children.length > 0 &&
        this.$refs.options.children[this.highlightedIndex].scrollIntoView({
          block: 'nearest'
        })
    },
    highlight(index) {
      this.highlightedIndex = index

      if (this.highlightedIndex < 0) {
        this.highlightedIndex = this.filteredOptions.length - 1
      }

      if (this.highlightedIndex > this.filteredOptions.length - 1) {
        this.highlightedIndex = 0
      }

      this.scrollToHighlighted()
    },
    highlightPrev() {
      this.highlight(this.highlightedIndex - 1)
    },
    highlightNext() {
      this.highlight(this.highlightedIndex + 1)
    },
    searchText() {
      this.$nextTick(() => {
        this.popper.scheduleUpdate()
      })
    },
    close() {
      if (!this.isOpen) {
        return
      }
      this.isOpen = false
      this.$refs.button.focus()
    },
    select(option) {
      const alreadySelect = this.model.product_id.find(
        el => el == option.product_id
      )
      if (!alreadySelect) {
        this.model.product_id.push(option.product_id)
      }
      this.$emit('input', this.model.product_id)
      this.$emit('change', this.model.product_id)
      this.search = ''
      this.option.push(option)
      this.highlightedIndex = this.filteredOptions.indexOf(option)
      this.close()
    },
    removeSelected(product) {
      this.open()
      this.option.splice(this.option.indexOf(product), 1),
        this.model.product_id.splice(
          this.model.product_id.indexOf(product.product_id),
          1
        )
      this.$emit('input', this.model.product_id)
      this.$emit('change', this.model.product_id)
    }
  }
}
</script>

<style lang="scss">
.search-select {
  position: relative;
}
.search-select-input {
  appearance: none;
  text-align: left;
  cursor: pointer;
  user-select: none;
  display: block;
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  font-size: 12px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  box-shadow: none;
  border-color: #d2d6de;
  white-space: nowrap;
  display: flex;
  align-items: center;
  border-radius: 0.25rem;

  &:focus {
    border-color: #3c8dbc;
  }

  &__disabled {
    background-color: #e5e9ed;
    opacity: 0.6;
  }
}
.search-select-placeholder,
.search-select-text {
  flex-grow: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.search-select__arrow {
  transition: all 200ms ease-in-out;

  &::before {
    display: block;
    color: #999;
    border-style: solid;
    border-width: 5px 5px 0;
    border-color: #999 transparent transparent;
    content: '';
  }

  &__open {
    transform: rotate(180deg);
  }
}
.search-select-dropdown {
  margin-top: -0.3rem;
  margin-bottom: -0.3rem;
  position: absolute;
  border-top: none !important;
  border-bottom: none !important;
  right: 0;
  left: 0;
  margin-left: 1px;
  width: 100%;
  background-color: #fff;
  border-radius: 0.25rem;
  // box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  z-index: 99999;
  border: solid 1px #d2d6de;
  display: flex;
  flex-direction: column;
}
.search-select-search {
  display: block;
  padding: 0.5rem 0.75rem;
  background-color: #ededed;
  border: 1px solid #ccc;
  margin: 0.5rem;
  border-radius: 3px;

  // &:focus {
  //   border-color: #3c8dbc;
  // }
}
.search-select-options {
  list-style: none;
  padding: 0;
  position: relative;
  overflow-y: scroll;
  max-height: 15rem;
  margin: 0;
}
.search-select-option {
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  user-select: none;

  &:hover {
    background-color: #e9e9e9;
    color: rgb(94, 94, 94);
  }

  &.is-active {
    background-color: #269add;
    color: #fff;
  }
}
.search-select-empty {
  text-align: center;
  padding: 0.5rem;
}
::-webkit-scrollbar {
  border-radius: 50px;
  width: 3px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}
/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  background: rgb(194, 194, 194);
}
</style>
